var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "plus_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 140967",
    transform: "translate(-.435 -.435)",
    fill: "none",
    d: "M0 0h12v12H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "icon plus",
    transform: "translate(.435 .435)",
    clipPath: "url(#plus_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Uni\\xE3o 13",
    d: "M4.749 9.234V6.38H1.894a.815.815 0 010-1.63H4.75V1.895a.816.816 0 011.631 0v2.856h2.855a.816.816 0 110 1.632H6.381v2.855a.816.816 0 11-1.631 0z",
    fill: "#378ff7",
    stroke: "rgba(0,0,0,0)"
  }))));
}
export default __webpack_public_path__ + "static/media/plus.735b9ce1.svg";
export { SvgPlus as ReactComponent };